<template>
  <el-card :body-style="{ boxSizing: 'border-box', height: '100%' }">
    <div class="card-ct">
      <el-tag
        :class="{ 'core-tag': isCorePackage, 'plus-tag': isPlusPackage }"
        size="small"
        v-if="showPackageTag"
      >
        {{ packageTagName }}
      </el-tag>
      <div class="info-wrapper">
        <div class="icon-ct">
          <div class="icon-section">
            <icon class="icon" :glyph="cardIcon" size="60" />
          </div>
        </div>
        <div class="info-ct">
          <p class="title">
            {{ cardTitle }}
          </p>
          <p class="description">
            {{ cardDescription }}
          </p>
        </div>
      </div>
      <div class="actions-ct">
        <slot></slot>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'DashboardCard',
  props: {
    packageTagName: {
      type: String,
      required: true
    },
    showPackageTag: {
      type: Boolean,
      required: true
    },
    cardIcon: {
      type: String,
      required: true
    },
    cardTitle: {
      type: String,
      required: true
    },
    cardDescription: {
      type: String,
      required: true
    },
    isCorePackage: {
      type: Boolean,
      required: false,
      default: false
    },
    isPlusPackage: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
.card-ct {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  position: relative;
}

.core-tag {
  background-color: #1d87c9;
  color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
}

.plus-tag {
  background-color: #1fca10;
  color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
}

.info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.icon-ct {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.icon-section {
  display: flex;
  justify-content: center;
}

.icon >>> svg {
  color: #1d87c8;
}

.info-ct {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.title {
  font-size: 20px;
  text-align: center;
}

.description {
  text-align: center;
  color: #9298a8;
  line-height: 18px;
}

.actions-ct {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/customer-intelligence/components/DashboardCard.vue